/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconClockPause = createReactComponent("outline", "clock-pause", "IconClockPause", [["path", { "d": "M20.942 13.018a9 9 0 1 0 -7.909 7.922", "key": "svg-0" }], ["path", { "d": "M12 7v5l2 2", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

export { IconClockPause as default };
//# sourceMappingURL=IconClockPause.mjs.map
